// 1. Define your AumicoUser claims interface
export interface AumicoUserClaims {
    name: string;
    picture: string;
    organizationId: string;
    internalId: string;
    roles: string[];
    dataCenter: string;
    // plus any other custom fields you’ve added...
}
